import { IGetAllUserAction } from './allUsers.interface';

export enum GetAllUserTypes {
	GET_ALL_USER = 'GET_ALL_USER',
}

export type GetAllUserAction = IGetAllUserAction;
